import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/screener/page.tsx");
